import type { SVGProps } from 'react'
import * as React from 'react'

const errorCircle = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C17.5229 22 22 17.5228 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#FF4752"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12 8V12" stroke="#FF4752" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 16H12.01" stroke="#FF4752" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default errorCircle
